import type { ButtonElements, ReusableButtonGroup } from "_types/Button"

export const useStrapiButtons = (
  buttons?: ButtonElements[] | null,
  reusable_button_group?: ReusableButtonGroup | null
) => {
  // checks to see if reusable buttons exist and returns the appropriate button array
  if (
    reusable_button_group?.button_group &&
    reusable_button_group.button_group.length > 0
  ) {
    return reusable_button_group.button_group
  }

  // if no reusable buttons exist it'll check buttons
  if (buttons && buttons.length > 0) return buttons
  // if both fail this condition, it will return undefined.
  return undefined
}
